import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormItemComponentInterface} from '../../../../interface/component';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {IFormItemsControls} from '../../../../interface/form-structure';

@Component({
    selector: 'noos-phone',
    templateUrl: './phone.component.html',
    styleUrls: ['./phone.component.scss']
})
@NoosFormTypeService.register('phone')
export class PhoneComponent implements OnInit, AfterViewInit, FormItemComponentInterface {

    prop: IFormItemsControls;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    lang = 'all';
    masks = {
        'tr-TR': ['\+', '9', '0', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
        'en-US': ['\+', '1', '0', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
        'en-UK': ['\+', '4', '4', ' ', /[0-9]/, /[0-9]/, /[0-9]/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
        'he-IL': ['\+', '9', '7', '2', '-', /[0-9]/, /[0-9]/, /[0-9]/, '-', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/],
    };
    mask;


    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    constructor() {
    }

    ngOnInit() {
        this.lang = this.prop.options.pattern.toString();
        this.mask = this.getMask();
    }

    ngAfterViewInit(): void {
    }

    getMask() {
        if (this.masks[this.lang] === undefined) {
            return {mask: false};
        }
        this.mask = this.masks[this.lang];
        return {mask: this.mask, keepCharPositions: true};
    }

}
